import React, { FC } from 'react';
import classNames from 'classnames';

import { PaymentMethodInfoTypeFragment } from 'domain/api/graphql/generated';

import CardEmpty from './CardEmpty';
import CardLogo from './CardLogo';
import CardSkeleton from './CardSkeleton';

import styles from './index.module.scss';

type BankCardProps = React.PropsWithChildren<{
  className?: string;
  isLoading: boolean;
  paymentMethod?: PaymentMethodInfoTypeFragment | null;
}>;

const BankCard: FC<BankCardProps> = ({ className, isLoading, paymentMethod }) => {
  if (!paymentMethod && isLoading) {
    return (
      <div className={classNames(styles.BankCard, className)}>
        <CardSkeleton />
      </div>
    );
  }

  return (
    <div className={classNames(styles.BankCard, className)}>
      {paymentMethod ? <CardLogo paymentMethod={paymentMethod} /> : <CardEmpty />}
    </div>
  );
};

export default React.memo(BankCard);
